/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { values, isEqual, difference } from "../../../utils/lodash-utils";

import Metrics from "./Metrics";
import { fetchMetrics } from "../api/metrics/actions";

const mapStateToProps = (state, props) => {
  let metricTypes = values(state.types.groups).filter(
    (metricType) => metricType.selected
  );
  const selectedmetrics = state.types.selectedMetricsGroup;
  selectedmetrics.forEach(function (item) {
    var metricItem = metricTypes.filter(
      (metricType) => metricType.metricType === item
    );
    metricTypes.splice(metricTypes.indexOf(metricItem[0]), 1);
    metricTypes.push(metricItem[0]);
  });

  const metrics = values(state.types.items)
    .filter((metric) => metric.selected)
    .map(({ id }) => id);
  const timerange = state.timerange.hours;
  const timerangeEndDate = state.timerange.endDate;
  let columns = state.columns;
  if (!columns) {
    columns = props.columns || 1;
  }

  const options = {
    timerange,
    timerangeEndDate,
  };

  return {
    metrics,
    metricTypes,
    columns,
    options,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { getMetrics } = ownProps;
  return {
    fetchMetrics: (contextValue, metricIds, options) => {
      const promises = metricIds.map((metricId) => {
        return getMetrics(contextValue, metricId, options);
      });
      return dispatch(
        fetchMetrics(() => {
          return Promise.all(
            promises.map((promise) => {
              return promise.catch((error) => {
                return {
                  contextValue,
                  error,
                };
              });
            })
          ).then((values) => values);
        }, metricIds)
      );
    },
  };
};

class MetricsRedux extends Component {
  getMetrics(props) {
    const { contextValue, fetchMetrics } = this.props;

    const previous = this.props.metrics;
    const next = props.metrics;

    if (isEqual(previous, next) && isEqual(this.props.options, props.options)) {
      return false;
    }
    // only fetch new metrics
    let diff = difference(next, previous);
    if (!isEqual(this.props.options, props.options)) {
      diff = next;
    }
    fetchMetrics(contextValue, diff, props.options);
  }

  componentWillMount() {
    this.getMetrics(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.getMetrics(nextProps);
  }

  render() {
    const { metricTypes } = this.props;
    if (metricTypes.length === 0) {
      return <div className="no-metrics">No metrics selected.</div>;
    }

    return <Metrics {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MetricsRedux);
